/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Newsletter_Success_TitleInputs */

const es_footer_newsletter_success_title = /** @type {(inputs: Footer_Newsletter_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción creada`)
};

const gl_footer_newsletter_success_title = /** @type {(inputs: Footer_Newsletter_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrición creada`)
};

const en_footer_newsletter_success_title = /** @type {(inputs: Footer_Newsletter_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription confirmed`)
};

/**
* | output |
* | --- |
* | "Subscription confirmed" |
*
* @param {Footer_Newsletter_Success_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_newsletter_success_title = /** @type {((inputs?: Footer_Newsletter_Success_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Newsletter_Success_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_newsletter_success_title(inputs)
	if (locale === "en") return en_footer_newsletter_success_title(inputs)
	return es_footer_newsletter_success_title(inputs)
});